/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { QueryDefinitionDto } from './query-definition-dto';
/**
 *
 *
 * @export
 * @interface DataSourceDto
 */
export interface DataSourceDto {
  /**
   * The name of the data source.
   *
   * @type {string}
   * @memberof DataSourceDto
   * @example Sessions base
   */
  name: string;

  /**
   * Type of datasource
   *
   * @type {string}
   * @memberof DataSourceDto
   * @example base
   */
  type: DataSourceDtoTypeEnum;

  /**
   * Query definition that describes what data to retrieve.
   *
   * @type {QueryDefinitionDto}
   * @memberof DataSourceDto
   */
  query_definition: QueryDefinitionDto;
}

/**
 * @export
 * @enum {string}
 */
export enum DataSourceDtoTypeEnum {
  Base = 'base',
  Custom = 'custom',
}
